import { render, staticRenderFns } from "./invoice5.vue?vue&type=template&id=6d82161c&scoped=true"
import script from "./invoice5.vue?vue&type=script&lang=js"
export * from "./invoice5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d82161c",
  null
  
)

export default component.exports